import React, { useEffect, useState } from 'react'

import {
    Typography, Paper, TextField,
    Stack, Grid, useMediaQuery, Button, Card, CardMedia, Snackbar, Alert
} from '@mui/material';

import Header from "../components/Header";
import Footer from "../components/Footer";
import SEO from '../components/SEO';

import { Box } from '@mui/system';


import Menu from '../components/Menu';
import BottomMenu from '../components/BottomMenu';
import { useDispatch, useSelector } from 'react-redux';
import { getReservedBooks, getSelectedBook } from '../redux/actions/bookAction';
import { addRequest } from '../redux/actions/requestAction';
import RequestConfirmation from '../components/dialogs/RequestConfirmation';
import { useHistory } from 'react-router-dom';
import moment from 'moment';

export default function ReservationForm() {
    const matches = useMediaQuery('(max-width:1150px)');
    const screenSize = useMediaQuery((theme) => theme.breakpoints.down('sm'));

    const book = useSelector((state => state.book))
    const user = useSelector((state => state.user))


    const [payload, setPayload] = useState({
        dateBorrowed: "",
        duration: "",
    })

    const handleChange = (prop) => (e) => {
        if (prop === 'duration') {
            if (e.keyCode !== 8 && e.target.value >= 0 && e.target.value <= 30) {
                setPayload({ ...payload, [prop]: e.target.value });
            } else {
                setAlert({
                    message: "Duration could only be greater than 0 and less than 30 days.",
                    severity: "error"
                })
                setSnack(true)
            }
        } else {
            setPayload({ ...payload, [prop]: e.target.value });
        }
    };

    const style = {
        background: {
            paddingLeft: 2,
            paddingRight: 2,
            borderRadius: 0,
            paddingBottom: 0,
            paddingTop: 5,
            '@media only screen and (max-width: 900px)': {
                paddingTop: 2
            },

        },
        body: {
            '@media only screen and (min-width: 480px)': {
                marginLeft: '4%',
                marginRight: '4%',
            },
            '@media only screen and (min-width: 1700px)': {
                marginLeft: '15%',
                marginRight: '15%',
            },
        },
        linkTexts: {
            textTransform: "none",
            color: (theme) => theme.palette.text.primary,
            fontWeight: "bold",
            fontSize: 18,
            "&: hover": {
                color: (theme) => theme.palette.primary.main,
                backgroundColor: "transparent"
            }
        },
        typography: {
            textAlign: "center",
            fontFamily: "Helvetica Neue",
            fontWeight: "bold",
            paddingBottom: 2,
            '@media only screen and (max-width: 900px)': {
                paddingBottom: 0,
                fontSize: 45,
                textAlign: "left"
            }
        },
        footerStyle: {
            position: "fixed",
            left: 0,
            bottom: 0,
            width: "100%",
            textAlign: "center"
        },
        label: {
            fontFamily: "Helvetica Neue",
            fontWeight: "bold",
            paddingBottom: 4,
        },
        divider: {
            marginTop: 4,
            marginBottom: 4
        },
        cardDashboard: {
            borderRadius: 0,
            boxShadow: 0,
            minHeight: 90,
            opacity: 0.9
        },
        actionButton: {
            margin: 0,
            padding: 1,
            height: 23,
            backgroundColor: "#B9E291",
            boxShadow: 0,
            borderRadius: 0,
            fontSize: 12,
        },
        scrollableDiv: {
            maxHeight: "100vh",
            '@media only screen and (min-width: 1700px)': {
                height: 700
            },
            '&::-webkit-scrollbar': {
                display: 'none'
            },
            overflow: 'auto',
            //for other browsers 
            scrollbarWidth: "none"
        },
        sideDiv: {
            position: "sticky",
            height: 500

        },
    }

    const [open, setOpen] = useState(false);

    const history = useHistory();
    const reserve = (e) => {
        e.preventDefault();
        var status = false;
        if (featuredBook.bookStatus.toLowerCase() === "borrowed") {
            setAlert({
                message: "This book is currently not available. ",
                severity: "error"
            })
            setSnack(true)

        } else {
            if (!payload.dateBorrowed || !payload.duration) {
                setAlert({
                    message: "Please complete the following fields.",
                    severity: "error"
                })
                setSnack(true)
            } else {
                for (var x = 0; x < book.reservedBooks.length; x++) {
                    if (book.reservedBooks[x] === featuredBook.bookID) {
                        status = true;
                    }
                }
                if (!status) {
                    dispatch(addRequest(featuredBook.bookID, payload.dateBorrowed, payload.duration));
                    history.push("/mybooks/requests")
                }
                else {
                    setAlert({
                        message: "You've already requested for this book. Please wait for further updates",
                        severity: "error"
                    })
                    setSnack(true)
                }
            }
        }
    }

    const featuredBook = book.selectedBook

    const dispatch = useDispatch();
    useEffect(() => {
        if (Object.keys(book.selectedBook).length <= 0) {
            dispatch(getSelectedBook());
        }

        if (!book.reserveEmpty && book.reservedBooks.length <= 0) {
            dispatch(getReservedBooks());
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const [snack, setSnack] = useState(false)

    const [alert, setAlert] = useState({
        message: "This is an alert message.",
        severity: "success",
    })


    const handleSnack = () => {
        setSnack(false);
    }

    const vertical = screenSize ? "bottom" : "top";
    const horizontal = "center";

    const today = moment().toISOString();;
    const nextmonth = moment(Date.now()).add(30, 'days').format('YYYY-MM-DD')

    const checkStatus = () => {
        if(Object.keys(book.selectedBook).length > 0) {
            return featuredBook.bookStatus.toLowerCase() === "borrowed"
        } else
        return false
    }
    return (
        <Box>
            <SEO title="My Books - Baliwag Municipal Library" description="RANIELLA VILLARAMA WEB DEVELOPER PORTFOLIO ... Services offered" />
            <Paper sx={style.background} elevation={0}>
                <Header />
                <Box sx={style.body}>
                    <Grid container columns={12} spacing={1}>
                        {!matches && <Grid item xs={12} md={3} sx={{ padding: 3 }}>
                            <Menu />
                        </Grid>}
                        <Grid item xs={12} md={matches ? 12 : 9}>
                            <Box sx={style.scrollableDiv}>
                                <Stack direction="column" sx={{ marginBottom: 2 }}>
                                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: "#280707" }}>You are about to reserve "{featuredBook.bookTitle}"</Typography>
                                    <Typography variant="subtitle2" sx={{ fontStyle: 'italic', color: "#280707" }}>One step away! Fill all the fields in this book request form and wait for further updates!</Typography>
                                </Stack>
                                <Grid container columns={12} spacing={2}>
                                    <Grid item xs={12} md={6} sx={{ marginTop: 3 }}>
                                        <Card elevation={0} sx={{ padding: 1 }}>
                                            <Stack direction="column" spacing={1} alignItems="center">
                                                <CardMedia
                                                    sx={{ width: 180 }}
                                                    component="img"
                                                    height={250}
                                                    image={featuredBook.bookCover}
                                                />
                                                <Typography variant='h6' sx={{ fontWeight: "bold" }}>{featuredBook.bookTitle}</Typography>
                                                <Typography variant='body2'>{featuredBook.bookAuthor}</Typography>
                                                <Typography variant='subtitle2' sx={{ fontStyle: "italic", textAlign: "center" }}>{featuredBook.bookDescription}</Typography>
                                               {checkStatus() && <Alert  severity={"warning"} sx={{ width: '100%' }}>
                                                    This book is currently not available.
                                                </Alert>}
                                            </Stack>

                                        </Card>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <Stack direction="column" spacing={2} sx={{ marginTop: 3 }}>
                                            <Grid container columns={12} spacing={1} justifyContent="center">
                                                <Grid item xs={12} md={6}>
                                                    <TextField
                                                        fullWidth
                                                        label='First Name'
                                                        value={user.currentUser.userFirstName}
                                                        inputProps={
                                                            { readOnly: true, }
                                                        } />
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <TextField
                                                        fullWidth
                                                        label='Last Name'
                                                        value={user.currentUser.userLastName}
                                                        inputProps={
                                                            { readOnly: true, }
                                                        } />
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <TextField
                                                        fullWidth
                                                        label='Library ID Number'
                                                        value={user.currentUser.libraryNumber}
                                                        inputProps={
                                                            { readOnly: true, }
                                                        }
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <TextField
                                                        fullWidth
                                                        value={user.currentUser.borrowerCard}
                                                        label='Borrower&apos;s Card Number'
                                                        inputProps={
                                                            { readOnly: true, }
                                                        }
                                                    />
                                                </Grid>
                                                {user.currentUser.borrowerCard === "" && user.currentUser.libraryNumber === "" && <Grid item xs={12}>
                                                    <Typography
                                                        variant="subtitle2"
                                                        sx={{
                                                            fontStyle: "italic",
                                                            fontSize: 11,
                                                            textAlign: "center"
                                                        }}>
                                                        Set up your borrower's card and library number on the profile's settings!
                                                    </Typography>
                                                </Grid>}
                                                <Grid item xs={12}>
                                                    <TextField
                                                        fullWidth
                                                        label='Address'
                                                        value={user.currentUser.userAddress}
                                                        inputProps={
                                                            { readOnly: true, }
                                                        }
                                                    />
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <TextField
                                                        fullWidth
                                                        label='Contact Number'
                                                        value={user.currentUser.userContact}
                                                        inputProps={
                                                            { readOnly: true, }
                                                        }
                                                    />
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <TextField
                                                        InputLabelProps={{ shrink: true }}
                                                        type='date'
                                                        label="Date of Pickup"
                                                        helperText="What day will you pick up this book?"
                                                        fullWidth
                                                        value={payload.dateBorrowed}
                                                        inputProps={{ min: moment(today).format('YYYY-MM-DD'), max: nextmonth }}
                                                        onChange={handleChange("dateBorrowed")}
                                                    />
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <TextField
                                                        helperText="How many days are you going to borrow this book?"
                                                        fullWidth
                                                        type='number'
                                                        label='Duration'
                                                        value={payload.duration}
                                                        onKeyPress={(event) => {
                                                            if (event?.key === '-' || event?.key === '+') {
                                                                event.preventDefault();
                                                            }
                                                        }}
                                                        onChange={handleChange("duration")}
                                                    />
                                                </Grid>

                                            </Grid>
                                            <Grid container justifyContent="center">
                                                <Button
                                                    variant="contained"
                                                    fullWidth
                                                    onClick={reserve}
                                                    sx={{
                                                        maxWidth: 250,
                                                        textAlign: "center",
                                                        backgroundColor: (theme) => theme.palette.primary.main,
                                                        "&:hover": {
                                                            backgroundColor: (theme) => theme.palette.primary.light,

                                                        },
                                                    }}>
                                                    Reserve
                                                </Button>
                                            </Grid>
                                        </Stack>
                                    </Grid>

                                </Grid>
                                <Box sx={{ height: 120 }} />
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Paper>
            <Snackbar open={snack} autoHideDuration={6000} onClose={handleSnack} anchorOrigin={{ vertical, horizontal }}>
                <Alert onClose={handleSnack} severity={alert.severity} sx={{ width: '100%' }}>
                    {alert.message}
                </Alert>
            </Snackbar>
            <Box sx={style.footerStyle}>
                {matches ?
                    <BottomMenu />
                    :
                    <Footer />}
            </Box>
            <RequestConfirmation open={open} setOpen={setOpen} />
        </Box>
    )
}
